module.exports = __webpack_public_path__ + "img/7764887.42e6daf7.jpg";